/* tslint:disable */
/* eslint-disable */
export enum WidgetType {
  DatePicker = 0,
  TextBox = 1,
  TextArea = 2,
  NumberBox = 3,
  Switch = 4,
  FuelPercentagePicker = 5,
  ImageUploader = 6,
  ReadOnlyInformation = 7,
  VideoUploader = 8,
  FileUploader = 9
}
